import { defineStore, storeToRefs } from 'pinia';
import { ref } from 'vue';
import type { languageList } from '@shared/types/Languages';
import type { InternationalLawList } from '@shared/types/InternationalLaw';
import { useBaseProfileStore } from '@/shared/stores/BaseProfileStore';

export const useUserStore = defineStore('user', () => {
  const motto = ref<string>('');
  const languageList = ref<languageList | never[]>([]);
  const imprint = ref<string>('');
  const onlineAdviceText = ref<string>('');
  const internationalLawList = ref<InternationalLawList | never[]>([]);
  const about = ref<string>('');

  return {
    motto,
    languageList,
    imprint,
    onlineAdviceText,
    internationalLawList,
    about,
    ...storeToRefs(useBaseProfileStore()),
  };
});
